export interface ShippingRegionDetails {
  id: string;
  shippingRegionHeaderId: string;
  shippingRegionKey: string;
  shippingRegionDescription: string;
  postcodes: string;
  shippingCharge: number;
}
